import { useMemo } from "react";
import { useLocation } from "react-router-dom";

export const useSimulationParams = () => {
  const location = useLocation();

  const searchParams = useMemo(() => {
    return new URLSearchParams(location.search);
  }, [location.search]);

  const simulationParams = useMemo(() => {
    const params = new URLSearchParams();
    const simRole = searchParams.get("simRole");
    const simCountryCode = searchParams.get("simCountryCode");
    const simTag = searchParams.get("simTag");
    const simCountries = searchParams.get("simCountries");
    const simAdmin = searchParams.get("simAdmin");

    if (simRole) params.set("simRole", simRole);
    if (simCountryCode) params.set("simCountryCode", simCountryCode);
    if (simTag) params.set("simTag", simTag);
    if (simCountries) params.set("simCountries", simCountries);
    if (simAdmin) params.set("simAdmin", simAdmin);

    return params.toString();
  }, [searchParams]);

  const createLink = (path: string) => {
    if (!simulationParams) return path;
    const separator = path.includes("?") ? "&" : "?";
    return `${path}${separator}${simulationParams}`;
  };

  return { simulationParams, createLink };
};
